import * as z from 'zod'

// Naming follows the conventions established in the WebGL package.
// Ref: https://github.com/github/brand-refactor-webgl
export const BrandEnum = z.enum(['Copilot', 'Security'])
export type Brand = z.infer<typeof BrandEnum>

export const DitherBrandEnum = z.enum(['Copilot', 'Security', 'Green'])
export type DitherBrand = z.infer<typeof DitherBrandEnum>
